import * as React from 'react';
import {ITextProps} from './ITextProps';
import {Base} from './Base';

export const Tt1 = (props: ITextProps) => {
  return <Base typoClass="typo1" {...props} />;
};
